<button
  class="toggle-btn bg-white hover:bg-vinciGrey-100 transition-colors duration-300 font-bold rounded-lg py-2 px-3"
  type="button"
  role="switch"
  [class.is-active]="isActive()"
  [attr.aria-checked]="isActive()"
  [attr.aria-label]="isActive() ? 'Désactiver' : 'Activer'"
  (click)="onToggle()"
>
  {{text()}}
  <svg
    class="toggle-icon"
    viewBox="0 0 44 24"
    aria-hidden="true"
    focusable="false"
  >
    <rect class="track" x="2" y="2" width="40" height="20" rx="10" />
    <circle class="thumb" cx="12" cy="12" r="8" />
    <path class="check" d="M27 12.5l3 3 6-6" />
  </svg>
</button>
